import {
  SET_WATCHER_EXISTS,
  UNSET_WATCHER_EXISTS,
  ADD_QUERIES_TO_WATCHER_EXISTS,
  DELETE_QUERY_FROM_WATCHER_EXISTS,
} from '../action-types';
import { WatcherSearchQueryEnum } from '../../watchers.types';

export const setWatcherExists = (
  watcherKey: string,
  types: Array<WatcherSearchQueryEnum>,
) =>
  <const>{
    type: SET_WATCHER_EXISTS,
    payload: { watcherKey, types },
  };

export const unsetWatcherExists = () =>
  <const>{
    type: UNSET_WATCHER_EXISTS,
  };

export const addQueriesToWatcherExists = (
  watcherKey: string,
  types: Array<WatcherSearchQueryEnum>,
) =>
  <const>{
    type: ADD_QUERIES_TO_WATCHER_EXISTS,
    payload: { watcherKey, types },
  };

export const removeQueryFromWatcherExists = (
  watcherKey: string,
  type: WatcherSearchQueryEnum,
) =>
  <const>{
    type: DELETE_QUERY_FROM_WATCHER_EXISTS,
    payload: { watcherKey, type },
  };

export type WatcherExistsActions = ReturnType<
  | typeof setWatcherExists
  | typeof unsetWatcherExists
  | typeof addQueriesToWatcherExists
  | typeof removeQueryFromWatcherExists
>;
